import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-flex align-items-center gap-3" }
const _hoisted_4 = { style: {"min-width":"180px"} }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table table-hover text-nowrap align-middle mb-0" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "fw-semibold text-primary" }
const _hoisted_11 = { class: "d-flex align-items-center gap-2" }
const _hoisted_12 = {
  class: "rounded-circle bg-primary text-white d-flex align-items-center justify-content-center",
  style: {"width":"30px","height":"30px","font-size":"12px","font-weight":"700","flex-shrink":"0"}
}
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = { class: "dropdown-menu" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "pagination-area d-md-flex mt-15 justify-content-between align-items-center" }
const _hoisted_20 = {
  class: "modal fade",
  id: "rejeterModal",
  tabindex: "-1",
  ref: "rejeterModalRef"
}
const _hoisted_21 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_22 = { class: "modal-content" }
const _hoisted_23 = { class: "modal-body" }
const _hoisted_24 = { class: "text-muted mb-3" }
const _hoisted_25 = { class: "modal-footer border-0 pt-0" }
const _hoisted_26 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
          _createElementVNode("h5", { class: "mb-0 fw-bold" }, "Demandes de commande")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Multiselect, {
              options: ['En attente', 'Validée', 'Rejetée'],
              searchable: true,
              modelValue: _ctx.filtreStatut,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtreStatut) = $event)),
              placeholder: "Tous les statuts",
              onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.charger(1))),
              onClear: _cache[2] || (_cache[2] = () => { _ctx.filtreStatut = ''; _ctx.charger(1); })
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("form", {
            class: "search-bg svg-color pt-3",
            onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.charger(1)), ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchTerm) = $event)),
              onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.charger(1))),
              class: "form-control shadow-none text-black",
              placeholder: "Référence, client, commercial..."
            }, null, 544), [
              [_vModelText, _ctx.searchTerm]
            ]),
            _cache[8] || (_cache[8] = _createElementVNode("button", {
              type: "submit",
              class: "bg-transparent text-primary transition p-0 border-0"
            }, [
              _createElementVNode("i", { class: "flaticon-search-interface-symbol" })
            ], -1))
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("table", _hoisted_7, [
            _cache[16] || (_cache[16] = _createElementVNode("thead", { class: "table-light" }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", null, "Référence"),
                _createElementVNode("th", null, "Commercial"),
                _createElementVNode("th", null, "Client"),
                _createElementVNode("th", null, "Montant TTC"),
                _createElementVNode("th", null, "Date"),
                _createElementVNode("th", null, "Statut"),
                _createElementVNode("th", { class: "text-end" }, "Actions")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_8, _cache[10] || (_cache[10] = [
                    _createElementVNode("td", {
                      colspan: "7",
                      class: "text-center py-4"
                    }, [
                      _createElementVNode("div", {
                        class: "spinner-border spinner-border-sm text-primary",
                        role: "status"
                      }),
                      _createElementVNode("span", { class: "ms-2 text-muted" }, "Chargement...")
                    ], -1)
                  ])))
                : (_ctx.demandes.length === 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_9, _cache[11] || (_cache[11] = [
                      _createElementVNode("td", {
                        colspan: "7",
                        class: "text-center py-4 text-muted"
                      }, [
                        _createElementVNode("i", { class: "fa fa-inbox fa-2x d-block mb-2" }),
                        _createTextVNode(" Aucune demande trouvée ")
                      ], -1)
                    ])))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.demandes, (d) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: d.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(d.refCom || '#' + d.id), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.initiales(d.user)), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.nomComplet(d.user)), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.nomComplet(d.client, true)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.formatMontant(d.montTTC)) + " FCFA", 1)
                        ]),
                        _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(d.createdAt)), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("span", {
                            class: _normalizeClass(['badge', _ctx.badgeClass(d.statut)])
                          }, _toDisplayString(d.statut || 'En attente'), 3)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_13, [
                            _cache[15] || (_cache[15] = _createElementVNode("button", {
                              class: "btn btn-primary dropdown-toggle",
                              type: "button",
                              "data-bs-toggle": "dropdown"
                            }, " Actions ", -1)),
                            _createElementVNode("ul", _hoisted_14, [
                              _createElementVNode("li", null, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'ViewVente', params: { id: d.id } },
                                  class: "dropdown-item d-flex align-items-center"
                                }, {
                                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createElementVNode("i", { class: "flaticon-eye me-2" }, null, -1),
                                    _createTextVNode("Détails ")
                                  ])),
                                  _: 2
                                }, 1032, ["to"])
                              ]),
                              (d.statut === 'En attente')
                                ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center text-success",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.valider(d))
                                    }, _cache[13] || (_cache[13] = [
                                      _createElementVNode("i", { class: "fa fa-check me-2" }, null, -1),
                                      _createTextVNode("Valider ")
                                    ]), 8, _hoisted_16)
                                  ]))
                                : _createCommentVNode("", true),
                              (d.statut === 'En attente')
                                ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                    _createElementVNode("a", {
                                      class: "dropdown-item d-flex align-items-center text-danger",
                                      href: "javascript:void(0);",
                                      onClick: ($event: any) => (_ctx.ouvriRejeter(d))
                                    }, _cache[14] || (_cache[14] = [
                                      _createElementVNode("i", { class: "fa fa-times me-2" }, null, -1),
                                      _createTextVNode("Rejeter ")
                                    ]), 8, _hoisted_18)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_PaginationComponent, {
            page: _ctx.page,
            totalPages: _ctx.totalPages,
            totalElements: _ctx.totalElements,
            limit: _ctx.limit,
            onPaginate: _ctx.handlePaginate
          }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "modal-header border-0 pb-0" }, [
            _createElementVNode("h5", { class: "modal-title fw-bold" }, [
              _createElementVNode("i", { class: "fa fa-times-circle text-danger me-2" }),
              _createTextVNode("Rejeter la demande ")
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("p", _hoisted_24, [
              _cache[17] || (_cache[17] = _createTextVNode(" Demande : ")),
              _createElementVNode("strong", null, _toDisplayString(_ctx.demandeSelectionnee?.refCom || '#' + _ctx.demandeSelectionnee?.id), 1)
            ]),
            _cache[18] || (_cache[18] = _createElementVNode("label", { class: "form-label fw-semibold" }, [
              _createTextVNode("Motif du rejet "),
              _createElementVNode("span", { class: "text-danger" }, "*")
            ], -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.motifRejet) = $event)),
              class: "form-control",
              rows: "4",
              placeholder: "Expliquez pourquoi cette demande est rejetée..."
            }, null, 512), [
              [_vModelText, _ctx.motifRejet]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _cache[20] || (_cache[20] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, [
              _createElementVNode("i", { class: "fa fa-times me-1" }),
              _createTextVNode(" Annuler ")
            ], -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.confirmerRejet && _ctx.confirmerRejet(...args))),
              disabled: !_ctx.motifRejet.trim()
            }, _cache[19] || (_cache[19] = [
              _createElementVNode("i", { class: "fa fa-check me-1" }, null, -1),
              _createTextVNode(" Confirmer le rejet ")
            ]), 8, _hoisted_26)
          ])
        ])
      ])
    ], 512)
  ], 64))
}